// The 3D back room behind the login and welcome windows: the table under the
// lamp with a few wizards idling, the camera slowly circling. three.js loads
// lazily; until then (or without WebGL) the drawn felt backdrop shows.
import { Suspense, lazy, useMemo } from "react";
import { DEFAULT_EQUIPPED, wizardLook } from "@wp/shared";
import { AUTOMATED } from "../../lib/useMediaQuery";
import { useSettings } from "../../settings/SettingsContext";
import type { SceneData } from "../../three/TableScene";
import { FeltBackdrop } from "./FeltBackdrop";

const TableCanvas = lazy(() => import("../../three/TableCanvas").then((m) => ({ default: m.TableCanvas })));

const GUESTS = [
  { slot: 1, color: "#2e86de", look: { hat: "10000002", robe: "20000002", head: "30000002" } },
  { slot: 2, color: "#8e44ad", look: { hat: "10000001", robe: "20000001", head: "30000001" } },
  { slot: 3, color: "#c0392b", look: { hat: "10000003", robe: "20000003", head: "30000003" } },
  { slot: 5, color: "#16a085", look: { hat: "10000001", robe: "20000002", head: "30000001" } },
];

function backdropScene(): SceneData {
  return {
    seats: GUESTS.map((g, i) => ({
      seat: g.slot,
      slot: g.slot,
      color: g.color,
      userId: `guest-${i}`,
      username: ["Morgana", "Gandalf", "Merlin", "Elminster"][i]!,
      isMe: false,
      look: wizardLook({ ...DEFAULT_EQUIPPED, ...g.look }),
      marks: [],
      isTurn: false,
      dim: false,
      cards: [null, null],
      shimmer: [null, null],
      bet: 20 + i * 15,
      stack: 480 - i * 40,
      cigar: i === 1 ? ("lit" as const) : ("none" as const),
      emote: null,
    })),
    community: [null, null, null],
    communityShimmer: [null, null, null],
    pot: 340,
    highlight: [],
  };
}

export function RoomBackdrop() {
  const { settings } = useSettings();
  const data = useMemo(backdropScene, []);
  const calm = settings.game.reduceAnimations || settings.accessibility.photosensitive || AUTOMATED;
  return (
    <div className="room-backdrop" aria-hidden="true">
      <Suspense fallback={<FeltBackdrop />}>
        {/* A backdrop: always the light version (no shadows, 1x pixels, 24 fps). */}
        <TableCanvas data={data} reduceEffects animate={!calm} autoRotate={!calm} maxFps={24} />
      </Suspense>
      <div className="room-vignette" />
    </div>
  );
}
